var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.8 7.4H4.05714C5.04714 7.4 5.85714 8.21 5.85714 9.2V18.2C5.85714 19.19 5.04714 20 4.05714 20H3.8C2.81 20 2 19.19 2 18.2V9.2C2 8.21 2.81 7.4 3.8 7.4ZM11 2C11.99 2 12.8 2.81 12.8 3.8V18.2C12.8 19.19 11.99 20 11 20C10.01 20 9.2 19.19 9.2 18.2V3.8C9.2 2.81 10.01 2 11 2ZM18.2 12.2857C19.19 12.2857 20 13.0957 20 14.0857V18.2C20 19.19 19.19 20 18.2 20C17.21 20 16.4 19.19 16.4 18.2V14.0857C16.4 13.0957 17.21 12.2857 18.2 12.2857Z",
    fill: "#0C66E4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.83cf425099df311895a81fc6d82a487a.svg";
export { ForwardRef as ReactComponent };